export const TYPE_PIECES_LIST_REQUESTING = 'type-pieces/TYPE_PIECES_LIST_REQUESTING';
export const TYPE_PIECES_LIST_SUCCESS = 'type-pieces/TYPE_PIECES_LIST_SUCCESS';
export const TYPE_PIECES_LIST_FAILED = 'type-pieces/TYPE_PIECES_LIST_FAILED';

export const PIECES_BY_TYPE_DEMANDS_REQUESTING = 'type-pieces/PIECES_BY_TYPE_DEMANDS_REQUESTING';
export const PIECES_BY_TYPE_DEMANDS_SUCCESS = 'type-pieces/PIECES_BY_TYPE_DEMANDS_SUCCESS';
export const PIECES_BY_TYPE_DEMANDS_FAILED = 'type-pieces/PIECES_BY_TYPE_DEMANDS_FAILED';

